import { UseQueryOptions } from '@tanstack/react-query';
import {
    ProductParameters,
    ProductResult,
    useRepositoryQuery,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useProductsQuery = (
    params: Partial<ProductParameters> = {},
    options?: Omit<UseQueryOptions<ProductResult, Error, ProductResult>, 'queryKey'>
) => {
    const currentEnterPriseId = useCurrentEnterpriseId();

    return useRepositoryQuery(
        'products',
        'getAll',
        {
            enterpriseIds: params.enterpriseIds ?? [currentEnterPriseId],
            ...params,
        },
        options
    );
};

export const useProductsSuspenseQuery = (
    params: Partial<ProductParameters> = {},
    options?: Omit<UseQueryOptions<ProductResult, Error, ProductResult>, 'queryKey'>
) => {
    const currentEnterPriseId = useCurrentEnterpriseId();

    return useRepositorySuspenseQuery(
        'products',
        'getAll',
        {
            enterpriseIds: params.enterpriseIds ?? [currentEnterPriseId],
            ...params,
        },
        options
    );
};
